import {
    CREATE_COMPACTING_INWARD_DETAILS_FAILURE_DK,
    CREATE_COMPACTING_INWARD_DETAILS_REQUEST_DK,
    CREATE_COMPACTING_INWARD_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_COMPACTING_INWARD_DETAILS_DK,
    DELETE_COMPACTING_INWARD_DETAILS_FAILURE_DK,
    DELETE_COMPACTING_INWARD_DETAILS_REQUEST_DK,
    DELETE_COMPACTING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_COMPACTING_INWARD_DETAILS_FAILURE_DK,
    FETCH_SINGLE_COMPACTING_INWARD_DETAILS_REQUEST_DK,
    FETCH_SINGLE_COMPACTING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_COMPACTING_INWARD_DETAILS_FAILURE_DK,
    FETCH_COMPACTING_INWARD_DETAILS_REQUEST_DK,
    FETCH_COMPACTING_INWARD_DETAILS_SUCCESS_DK,
    COMPACTING_INWARD_DETAILS_USERFORM_RESET_DK,
    UPDATE_COMPACTING_INWARD_DETAILS_FAILURE_DK,
    UPDATE_COMPACTING_INWARD_DETAILS_REQUEST_DK,
    UPDATE_COMPACTING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_COMPACTING_INWARD_DETAILS_BY_ID_REQUEST_DK,
    FETCH_COMPACTING_INWARD_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_FAILURE_DK,
    FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_REQUEST_DK,
    COMPACTING_INWARD_DETAILS_DC_DETAILS_DISABLED_DK
} from './compactingInwardDetails.actionsType';

export const COMPACTING_INWARD_DETAILS_DK = 'compactingInwardDetailsDK';

let initialState = {
    loading: false,
    compactingInwardDetailsById: [],
    compactingInwardDetails: [],
    previousGetList: [],
    isDCDetailDisabled: false,
    compactingInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0,
        fldReceivingRolls: 0
    },
    selectedCompactingInwardDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let compactingInwardDetailsDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_COMPACTING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_COMPACTING_INWARD_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_COMPACTING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_COMPACTING_INWARD_DETAILS_REQUEST_DK:
        case UPDATE_COMPACTING_INWARD_DETAILS_REQUEST_DK:
        case DELETE_COMPACTING_INWARD_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_COMPACTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                compactingInwardDetails: updatePayload
            };
        case FETCH_COMPACTING_INWARD_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                compactingInwardDetailsById: updatePayload
            };
        case FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload?.COI
            };

        case CREATE_COMPACTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                compactingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldReceivingRolls: 0
                },
                isDCDetailDisabled: false
            };
        case FETCH_SINGLE_COMPACTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedCompactingInwardDetails: updatePayload,
                compactingInwardDetailsForm: {
                    ...updatePayload
                }
            };
        case UPDATE_COMPACTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedCompactingInwardDetails: {},
                compactingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldReceivingRolls: 0
                },
                isDCDetailDisabled: false
            };
        case DELETE_COMPACTING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                compactingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldReceivingRolls: 0
                },
                isDCDetailDisabled: false,
                selectedCompactingInwardDetails: {}
            };
        case COMPACTING_INWARD_DETAILS_DC_DETAILS_DISABLED_DK:
            return {
                ...state,
                isDCDetailDisabled: payload
            };
        case FETCH_COMPACTING_INWARD_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_COMPACTING_INWARD_DETAILS_FAILURE_DK:
        case FETCH_PREVIOUS_COMPACTING_INWARD_DETAILS_FAILURE_DK:
        case CREATE_COMPACTING_INWARD_DETAILS_FAILURE_DK:
        case UPDATE_COMPACTING_INWARD_DETAILS_FAILURE_DK:
        case DELETE_COMPACTING_INWARD_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_COMPACTING_INWARD_DETAILS_DK:
            return {
                ...state,
                loading: false,
                compactingInwardDetailsForm: {
                    ...state.compactingInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case COMPACTING_INWARD_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                compactingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldReceivingRolls: 0
                },
                isDCDetailDisabled: false,
                selectedCompactingInwardDetails: {}
            };
        default:
            return state;
    }
};
